import React, { act, useEffect, useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { FaPersonWalking } from "react-icons/fa6";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useAttendanceList, useRegenerateExpense } from "../hooks/useEmployee";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import ReleaseAllDayModal from "./ReleaseAllDayModal";
import AttendanceModal from "./AttendanceModal";
import { Btn } from "../../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import { resetDropDown, setMonth, setYear } from "../../../ReduxToolkit/Reducers/Employee/AttendanceListModule";
import { useHardRefresh } from "../../../Component/BasicComponents/Hooks/useHardRefresh";
import { BASE_URL } from "../../../Api/config";
import { downloadExcelGet } from "../../../utils/ExcelDownload";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import { showToast } from "../../../utils/toastUtils";

const ExpenseModalContent = ({ toggleModal, EmployeeId, Date }: any) => {
  const { mutate } = useRegenerateExpense();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const payload = {
      empId: EmployeeId,
      month: Date,
    };

    mutate(payload);
    toggleModal();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row mb-3">
        Are you sure want to generate monthly expense?
      </div>

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          Yes
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={toggleModal}
        >
          No
        </Btn>
      </div>
    </form>
  );
};

const AttendanceList = ({ employeeData }: any) => {
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [dateRange, setDateRange] = useState("");
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [isExpenseModal, setIsExpenseModal] = useState(false);
  const [singleAttendance, setSingleAttendance] = useState();
  const [isAttendance, setIsAttendance] = useState(false);
    const [Disabled,setDisabled] = useState<boolean>(false);
        const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
            const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
            const { startPolling, stopPolling } = useExcelPolling();

    const dispatch = useDispatch() 
    const { filter,dropDown } = useSelector((state: any) => state.attendanceModule); // 👈 now Redux filter

console.log('attenance Dropdown',dropDown)
useEffect(() => {
  const today = new Date();
  const monthName = today.toLocaleString("default", { month: "long" });
  const year = String(today.getFullYear());

  // ✅ Set local states
  setSelectedMonth(monthName);
  setSelectedYear(year);

  // ✅ Update Redux state so dropdowns show current year & month
  dispatch(setYear({ id: year, label: year }));
  dispatch(setMonth({ id: monthName, label: monthName }));

  // ✅ Set date range for API call
  setDateRange(getMonthRange(monthName, year));
}, [dispatch]);


  const { data: Attendance,isLoading } = useAttendanceList({
    enabled: !!dateRange && !!employeeData?.EmployeeId,
    params: {
      empId: employeeData.EmployeeId,
      month: dateRange,
    },
  });

  const AttendanceListColumns = (
    handleAttendanceView: (row: any) => void
  ): any[] => [
    {
      name: "Date",
      selector: (row: { Date: string }) => row.Date,
      sortable: true,
      width: "130px",
      headCells: {
        style: {
          "&:first-of-type": {
            position: "sticky",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 3, // must be higher than rows
          },
        },
      },
      style: {
        position: "sticky",
        left: 0,
        backgroundColor: "#fff", // Make sure it covers scroll area
        zIndex: 3,
        borderRight: "1px solid #ddd",
      },
    },
    {
      name: "Start time",
      selector: (row: { StartTime: string }) => row.StartTime,
      sortable: true,
      width: "160px",
    },

    {
      name: "Actual Start at",
      selector: (row: { punchindate: string }) => row.punchindate,
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },

    {
      name: "Start town",
      selector: (row: { StartTownName: string }) => row.StartTownName,
      sortable: true,
      width: "150px",
    },
    {
      name: "End time",
      selector: (row: { EndTime: string }) => row.EndTime,
      sortable: true,
      width: "150px",
    },
    {
      name: "Actual End at",
      selector: (row: { punchoutdate: string }) => row.punchoutdate,
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "End town",
      selector: (row: { EndTownName: string }) => row.EndTownName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Remark",
      selector: (row: { Remark: number }) => row.Remark,
      sortable: true,
      width: "150px",
    },
    {
      name: "Visited town",
      selector: (row: { VisitedTownName: string }) => row.VisitedTownName,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: "Total calls",
      selector: (row: { TotalCalls: number }) => row.TotalCalls,
      sortable: true,
      width: "150px",
    },
    {
      name: "Distance Km",
      selector: (row: { Distance: number }) => row.Distance,
      sortable: true,
      width: "150px",
    },
    {
      name: "Expense Remark",
      cell: (row: { ExpenseRemark: number }) => row.ExpenseRemark,
      sortable: true,
      width: "170px",
    },
    {
      name: "Status",
      cell: (row: { Status: string }) => {
        let bgColor = "";

        const status = row.Status?.toLowerCase();

        if (status === "punch-in") {
          bgColor = "#d4edda"; // light green
        } else if (
          status === "leave" ||
          status === "week-off" ||
          status === "holiday"
        ) {
          bgColor = "#fff3cd"; // light yellow
        } else if (status === "punch-out") {
          bgColor = "#f8d7da"; // light red
        } else {
          bgColor = "#e2e3e5"; // default grey
        }

        return (
          <div
            style={{
              backgroundColor: bgColor,
              padding: "4px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
            }}
          >
            {row.Status}
          </div>
        );
      },
      sortable: true,
    },
    {
  name: "Actions",
  cell: (row: any) => {
    // hide buttons if row.Type is "No Data"
    if (!row.raw?.AttendanceId) return null;

    return (
      <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
        <button
          onClick={() => handleAttendanceView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "5px",
            padding: "5px 10px",
            width: "fit-content",
            backgroundColor: "#2e8dd3",
          }}
          title="Edit Attendance"
        >
          <FaEdit style={{ fontSize: 15, fill: "#ffffff" }} />
        </button>
        <button
          onClick={() => handleCallView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "5px",
            padding: "5px 10px",
            width: "fit-content",
          }}
          title="Daily call view"
        >
          <FaPersonWalking style={{ fontSize: 20, fill: "#fff" }} />
        </button>
      </div>
    );
  },
}

  ];

  const formatAttendanceData = (data: any) => {
    if (!data) return [];

    return Object.values(data).map((entry: any) => {
      const isNoData = entry.Type === "No Data";

      return {
        Date: new Date(entry.Date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }), // e.g., "01 May"
        StartTime: entry.StartTime ? formatTime(entry.StartTime) : "--",
        StartTownName: entry.StartTownName || "--",
        EndTime: entry.EndTime ? formatTime(entry.EndTime) : "--",
        EndTownName: entry.EndTownName || "--",
        VisitedTownName: entry.VisitedTownName || "--",
        TotalCalls: entry.TotalCalls ?? 0,
        Status: entry.Status || entry.Type || "--",
        raw: entry, // pass raw entry for actions
        ExpenseRemark: entry.ExpenseRemark || "--",
        Remark: entry.Remark || "--",
        Distance: entry?.DistanceKM || "--",
        punchoutdate: entry?.punchoutdate
          ? formatDateTime(entry.punchoutdate)
          : "--",
        punchindate: entry?.punchindate
          ? formatDateTime(entry?.punchindate)
          : "--",
      };
    });
  };

  const formatTime = (timeStr: string) => {
    const date = new Date(`1970-01-01T${timeStr}`);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const formatDateTime = (dateTimeStr: string) => {
    // Replace the space with 'T' to make it a valid ISO 8601 string
    const date = new Date(dateTimeStr.replace(" ", "T"));

    return date.toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleAttendanceView = (e: any) => {
    // alert("Attendance View");
    setSingleAttendance(e);
    setIsAttendance(!isAttendance);
  };
  const handleCallView = (e: any) => {
    navigate("/employee/DailyCallView", { state: { e, employeeData } });
  };

  const currentYear = new Date().getFullYear();
  const startingYear = 2022; // or your desired start year

  const YearOptions = Array.from(
    { length: currentYear - startingYear + 1 },
    (_, i) => {
      const year = startingYear + i;
      return { id: year.toString(), label: year.toString() };
    }
  ).reverse();

  const getMonthsUpToCurrent = (year: string) => {
    const current = new Date();
    const monthIndexLimit =
      current.getFullYear() === Number(year) ? current.getMonth() : 11;

    const allMonths = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return allMonths.slice(0, monthIndexLimit + 1).map((month) => ({
      id: month,
      label: month,
    }));
  };

  const getMonthRange = (month: string, year: string) => {
    if (!month || !year) return "";

    const parsedDate = new Date(`${month} 1, ${year}`);
    if (isNaN(parsedDate.getTime())) {
      console.error("Invalid month or year:", month, year);
      return "";
    }

    const monthIndex = parsedDate.getMonth();
    const start = new Date(Number(year), monthIndex, 1);
    const end = new Date(Number(year), monthIndex + 1, 0);

    const formatDateToLocalYYYYMMDD = (date: Date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    // const format = (date: Date) => date.toISOString().split("T")[0];

    return `${formatDateToLocalYYYYMMDD(start)}|${formatDateToLocalYYYYMMDD(
      end
    )}`;
  };


   useHardRefresh(()=> dispatch(resetDropDown()))
  const toggleAttendanceModal = () => {
    setIsAttendance(!isAttendance);
  };
  const toggleModal = () => {
    setIsModal(!isModal);
  };

  const toggleExpenseModal = () => {
    setIsExpenseModal(!isExpenseModal);
  };

//   const handleAttendanceExcel=async()=>{
//     const appToken = localStorage.getItem("Apptoken")||"";
//        const params: Record<string, any> = {
//       // action: "download",
//       empId:employeeData.EmployeeId,
//      month:dateRange
//       // ...(filterData.end_date === "" ? {} : { end_date: filterData.end_date }),
//     };
// const queryString = new URLSearchParams(params).toString();
// const apiEndpoint = `${BASE_URL}admin/api/getListAttendanceExcel?${queryString}`;

//     const fileName = 'AttendanceListData.xlsx'
//      try{
//               setDisabled(true);
//               const response =  await downloadExcelGet({ apiEndpoint, appToken, fileName });
//                 if(response.success){
//                   setDisabled(false);
//                 }
//             }catch(error:any){  
//                console.log('Error While downLoading Excle');
//             }finally{
//               setDisabled(false);
//             }
//   }

         const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
const  empId= employeeData.EmployeeId;
      const month =dateRange;


    const params = new URLSearchParams();

    // Append only if the value exists

    // if (sortColumn) params.append("sortColumn", sortColumn);
    if (empId) params.append("empId", empId);
    if (month) params.append("month", month);
    
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_ATTENDANCE_LIST_EXCEL}?${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => {showToast.error(msg || "");setLoadingExcel(false)},
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
        setLoadingExcel(false)
      }
    };


  return (
    <div>
      <BasicDataTable
  
        dynamicHeightOnRowsPerPage={true}
        showSpinner={isLoading}
        customStyle={{
          headCells: {
            style: {
              fontSize: 14,
              fontWeight: "bold",
              zIndex: 2, // keep it above body cells
              "&:first-of-type": {
                position: "sticky",
                left: 0,
                zIndex: 3,
                backgroundColor: "#fff",
              },
            },
          },
          head: {
            style: {
              backgroundColor: "red",
              zIndex: 4,
            },
          },
        }}
        search={false}
        Title="Attendance"
        columns={AttendanceListColumns(handleAttendanceView)}
        data={formatAttendanceData(Attendance?.data)}
        pagination={false}
        onChangeRowsPerPage={500}
        // paginationTotalRows={2000}
         topLeftAlignContent={<>
         <button
         disabled={loadingExcel}
              className="btn btn-primary"
              onClick={downloadExcelGet}
              style={{
                borderRadius: "20px",
                padding: "3px 10px",
                marginRight:'10px',
                width: "fit-content",
              }}
            >
              Excel
            </button></>}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "5px",
              marginBottom: 10,
            }}
          >
            <select
              style={{
                backgroundColor: "#2E8DD3",
                color: "#fff",
                padding: "5px",
                borderRadius: "20px",
                border: "0px",
              }}
              value={dropDown.year.id}
              onChange={(e) => {
                const newYear = e.target.value;
                dispatch(setYear({ id: newYear, label: newYear }));
                // setSelectedYear(newYear);

                if (selectedMonth) {
                  const range = getMonthRange(selectedMonth, newYear);
                  setDateRange(range); // ✅ update range so API refetches
                }
              }}
            >
              {YearOptions.map((y) => (
                <option
                  style={{
                    backgroundColor: "#fff" /* only works in some browsers */,
                    color: "#000",
                  }}
                  key={y.id}
                  value={y.id}
                >
                  {y.label}
                </option>
              ))}
            </select>

            {/* Month Dropdown */}
            <select
              style={{
                backgroundColor: "#2E8DD3",
                color: "#fff",
                padding: "5px",
                borderRadius: "20px",
                border: "0px",
              }}
              value={dropDown.month.id}
              onChange={(e) => {
                const newMonth = e.target.value;
                  dispatch(setMonth({ id: newMonth, label: newMonth }));
                // setSelectedMonth(newMonth);

                if (selectedYear) {
                  const range = getMonthRange(newMonth, selectedYear);
                  setDateRange(range); // ✅ update range so API refetches
                }
              }}
            >
              {getMonthsUpToCurrent(selectedYear).reverse().map((m) => (
                <option
                  style={{
                    backgroundColor: "#fff" /* only works in some browsers */,
                    color: "#000",
                  }}
                  key={m.id}
                  value={m.label}
                >
                  {m.label}
                </option>
              ))}
            </select>
          </div>
        }
        TableBottomButton={true}
        TableBottomButtonContent={
          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button
              className="btn btn-primary"
              style={{
                borderRadius: "5px",
                padding: " 5px 10px",
                width: "fit-content",
                height: "fit-content",
              }}
              onClick={toggleModal}
            >
              Release All day lock
            </button>
            <button
              className="btn btn-primary"
              style={{
                borderRadius: "5px",
                padding: "5px 10px",
                width: "fit-content",
                height: "fit-content",
                backgroundColor: "#2e8dd3",
              }}
              onClick={toggleExpenseModal}
            >
              Generate Monthly Expense
            </button>
          </div>
        }
      />
      <RouteModal
        isOpen={isModal}
        toggle={toggleModal}
        title={""}
        size="sm"
        content={
          <ReleaseAllDayModal
            EmployeeId={employeeData.EmployeeId}
            toggleModal={toggleModal}
          />
        }
      />

      <RouteModal
        isOpen={isExpenseModal}
        toggle={toggleExpenseModal}
        title={""}
        size="sm"
        content={
          <ExpenseModalContent
            toggleModal={toggleExpenseModal}
            EmployeeId={employeeData.EmployeeId}
            Date={dateRange}
          />
        }
      />

      <RouteModal
        isOpen={isAttendance}
        toggle={toggleAttendanceModal}
        title={"Edit Attendance"}
        size="md"
        content={
          <AttendanceModal
            employeeData={employeeData}
            attendanceData={singleAttendance}
            toggleModal={toggleAttendanceModal}
          />
        }
      />
    </div>
  );
};

export default AttendanceList;
